module.exports = __webpack_public_path__ + "static/media/archery04.dbef9bfc.jpg";